import React from 'react';
import './AdminEmptyPage.css';

const AdminEmptyPage = () => {
  return (
    <div className="admin-empty-page">
      <h2>Добро пожаловать в панель администратора</h2>
      <p>Выберите раздел в меню выше для начала работы</p>
    </div>
  );
};

export default AdminEmptyPage;